import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaCheckCircle, FaCrown } from 'react-icons/fa';
import './Planos.css';

const PlanCard = ({
  title,
  priceMonthly,
  activationAnnual,
  description,
  features,
  highlight = false,
  ctaLabel,
  ctaHref
}) => {
  return (
    <div className={`plan-card ${highlight ? 'highlight' : ''}`}>
      {highlight && (
        <div className="plan-badge">
          <FaCrown className="plan-badge-icon" />
          <span>Mais popular</span>
        </div>
      )}
      <div className="plan-header">
        <h3 className="plan-title">{title}</h3>
        <p className="plan-description">{description}</p>
      </div>

      <div className="plan-price">
        {priceMonthly && (
          <div className="price-line">
            <span className="price-label">Mensal</span>
            <span className="price-value">{priceMonthly}</span>
          </div>
        )}
        {activationAnnual && (
          <div className="price-line">
            <span className="price-label">Ativação Anual</span>
            <span className="price-value">{activationAnnual}</span>
          </div>
        )}
      </div>

      <ul className="plan-features">
        {features.map((featureText, index) => (
          <li key={index}>
            <FaCheckCircle className="feature-icon" />
            <span>{featureText}</span>
          </li>
        ))}
      </ul>

      <div className="plan-cta">
        <a className="cta-button" href={ctaHref}>
          {ctaLabel}
        </a>
      </div>
    </div>
  );
};

const Planos = () => {
  // Função para gerar links do WhatsApp com mensagens personalizadas
  const generateWhatsAppLink = (phone, message) => {
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${phone}?text=${encodedMessage}`;
  };

  // Números de telefone
  const phones = {
    danuza: "5553999096040"
  };

  // Mensagens personalizadas para cada plano
  const messages = {
    essencial: "Olá! Tenho interesse no *Plano Essencial* (R$ 29,90/mês). Gostaria de mais informações sobre como assinar e começar a usar o app. Obrigado!",
    premium: "Olá! Tenho interesse no *Plano Premium* (R$ 49,90/mês). Gostaria de mais informações sobre o acesso ilimitado ao App e SaaS. Obrigado!",
    anual: "Olá! Tenho interesse na *Ativação Anual do App* (R$ 200,00). Gostaria de mais informações sobre como ativar e as vantagens do pagamento único. Obrigado!"
  };

  return (
    <div className="planos-page">
      <section className="planos-hero">
        <Container>
          <h1>Planos e Preços</h1>
          <p>Escolha a opção ideal para o seu momento profissional.</p>
        </Container>
      </section>

      <Container className="planos-content">
        <Row className="pricing-grid">
          <Col xs={12} md={6} lg={3} className="pricing-col">
            <PlanCard
              title="Plano Essencial"
              priceMonthly="R$ 29,90"
              description="Para quem está começando ou tem uma base menor de clientes."
              features={[
                'Acesso exclusivo ao App',
                'Suporte para até 30 pacientes',
                'Limite de 300 sessões'
              ]}
              ctaLabel="Assinar via WhatsApp"
              ctaHref={generateWhatsAppLink(phones.danuza, messages.essencial)}
            />
          </Col>

          <Col xs={12} md={6} lg={3} className="pricing-col">
            <PlanCard
              title="Plano Premium"
              priceMonthly="R$ 49,90"
              description="Para quem precisa de ferramentas completas e escala ilimitada."
              features={[
                'Acesso ilimitado ao App e ao SaaS',
                'Pacientes e sessões ilimitados'
              ]}
              highlight
              ctaLabel="Assinar Premium"
              ctaHref={generateWhatsAppLink(phones.danuza, messages.premium)}
            />
          </Col>

          <Col xs={12} md={6} lg={3} className="pricing-col">
            <PlanCard
              title="Ativação Anual (App)"
              activationAnnual="R$ 200,00"
              description="Melhor custo-benefício para usar apenas o App (somente para clientes)."
              features={[
                'Acesso completo ao App por 1 ano',
                'Pagamento único',
                'Economia de R$ 158,80 vs. mensal'
              ]}
              ctaLabel="Ativar via WhatsApp"
              ctaHref={generateWhatsAppLink(phones.danuza, messages.anual)}
            />
          </Col>

          <Col xs={12} md={6} lg={3} className="pricing-col">
            <PlanCard
              title="Oferta BTone"
              activationAnnual="R$0,00"
              description="Incluso na compra do equipamento BTone."
              features={[
                'Essencial gratuito por 1 ano',
                'Degustação de 1 mês do SaaS'
              ]}
              ctaLabel="Ver Equipamento"
              ctaHref="/produtos"
            />
          </Col>
        </Row>

        <Row className="additional-info-section">
          <Col xs={12} className="d-flex justify-content-center">
            <div className="activation-card">
              <div className="plan-header">
                <h3 className="plan-title">Taxa de Ativação</h3>
                <p className="plan-description">Para equipamentos externos que necessitam ativação via MAC</p>
              </div>

              <div className="plan-price">
                <div className="price-line">
                  <span className="price-label">Pagamento Único</span>
                  <span className="price-value">R$ 1.300</span>
                </div>
              </div>

              <ul className="plan-features">
                <li>
                  <FaCheckCircle className="feature-icon" />
                  <span>Envio de bocais (adaptativo + avaliação)</span>
                </li>
                <li>
                  <FaCheckCircle className="feature-icon" />
                  <span>Ativação via MAC do equipamento</span>
                </li>
                <li>
                  <FaCheckCircle className="feature-icon" />
                  <span><strong>Plano Essencial incluído por 1 ano</strong></span>
                </li>
                <li>
                  <FaCheckCircle className="feature-icon" />
                  <span><strong>Degustação do SaaS por 1 mês</strong></span>
                </li>
              </ul>

              <div className="plan-cta">
                <a className="cta-button" href={generateWhatsAppLink(phones.danuza, "Olá! Tenho interesse na *Taxa de Ativação para Equipamento Externo* (R$ 1.300). Gostaria de mais informações sobre o processo de ativação e os benefícios inclusos. Obrigado!")}>
                  Solicitar Ativação
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Planos;

